export default {
  icon_text: 'Geschlossen',
  buttons: {
    ok: 'Ok',
  },
};
